export default class StringHelper {
  public static isNullOrWhitespace(input: string | null | undefined): boolean {
    if (!input) {
      return true;
    }
    return input.trim().length == 0;
  }
  public static upperCaseAndReplaceDiacritics(value: string | null): string {
    if (value == null) return "";
    return value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLocaleUpperCase();
  }

  public static upperCaseFirstLetterAndReplaceDiacritics(
    value: string | null
  ): string {
    if (value == null || value.length === 0) return "";
    return (
      value.charAt(0).toLocaleUpperCase() +
      value
        .slice(1)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
    );
  }

  public static removeSpaces(chaine: string | null): string {
    if (chaine == null) return "";
    const regex = / /g;
    return chaine.replace(regex, "");
  }
}
